/**
 * 本から TODO を作るフォーマットの編集シート。図書館画面のヘッダーメニューから開く。
 *
 * 閉じると中の編集画面がアンマウントされ、書きかけの内容もそこで保存される。
 */

import { useEffect } from 'react'
import { toast } from 'sonner'

import { BottomSheet } from '@/components/ui/bottom-sheet'
import { useBookTodoTemplateStore } from '@/store/useBookTodoTemplateStore'

import { BookTodoTemplateEditor } from './BookTodoTemplateEditor'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const BookTodoFormatSheet = ({ open, onOpenChange }: Props) => {
  const isLoaded = useBookTodoTemplateStore((s) => s.isLoaded)
  const loadTemplates = useBookTodoTemplateStore((s) => s.loadTemplates)
  const loadProjects = useBookTodoTemplateStore((s) => s.loadProjects)

  useEffect(() => {
    if (!open) return
    loadTemplates().catch(() => toast.error('フォーマットの読み込みに失敗しました'))
    // TODO 側でプロジェクトが増えていることがあるので、開くたびに取り直す
    loadProjects().catch(() => toast.error('プロジェクトの読み込みに失敗しました'))
  }, [open, loadTemplates, loadProjects])

  return (
    <BottomSheet title="TODO のフォーマット" open={open} onOpenChange={onOpenChange} snapPoints={[0.85]}>
      <div className="space-y-4 px-4 pb-6">
        <p className="text-xs text-muted-foreground">
          本カードの TODO ボタンで使います。フォーマットが 1 つならすぐ追加し、2 つ以上なら選べます。
        </p>
        {isLoaded && <BookTodoTemplateEditor />}
      </div>
    </BottomSheet>
  )
}
